import {
    mapState,
    mapMutations
} from 'vuex'
export default {
    computed: {
        ...mapState({
            loginType: state => state.loginType,
            actives: state => state.actives,
            activeIndex2: state => state.activeIndex,
            lang: state => state.lang,
            bannerList: state => state.bannerList,
            userInfo: state => state.userInfo,
            step2: state => state.step,

        })

    },
    watch: {
        lang: {
            immediate: true,
            handler: function(newV) {
                if (this.$route) {
                    if (this.$route.path.indexOf('forum') > -1 || this.$route.path.indexOf('newsnotice') > -1 || this.$route.path.indexOf('generalassembly') > -1) {
                        document.title = this.$route.meta.Chinese
                    } else {

                        if (this.lang == 'zh') {
                            // console.log(this.$route.meta, 'this.$route.meta');
                            document.title = this.$route.meta.Chinese
                        } else {
                            document.title = this.$route.meta.English
                        }
                    }
                }
            }

        },
    },
    methods: {
        ...mapMutations([
            'SETACTIVES',
            'SETACTIVE',
            'SETLANG',
            'SETLOGINTYPE',
            'SETBANNERLIST',
            'SETUSERINFO',
            'SETSTEP'

        ]),
        pushParam(obj) {
            this.$router.push({
                path: this.$route.path,
                query: {...obj }
            });
        },
        isVideo(url) {
            // 常用视频格式
            const videolist = ["mp4", "m2v", "mkv", "rmvb", "wmv", "avi", "flv", "mov", "m4v"];
            if (url.lastIndexOf('.') > -1) {
                var suffix = url.substr(url.lastIndexOf('.') + 1)
                var result = videolist.find(item => item === suffix);
                if (result) {
                    return true;
                }
            }
            return false
        },
        // 未登录
        checkLogin() {
            var tip = this.lang == "zh" ? "请登录" : "Please login";
            if (!this.userInfo.customerType) {
                this.$message({
                    message: tip,
                });
                return false;
            }

            return true;
        },
    }
}